import { render, staticRenderFns } from "./td-tradeOpt.vue?vue&type=template&id=81b06f0e&"
import script from "./td-tradeOpt.vue?vue&type=script&lang=js&"
export * from "./td-tradeOpt.vue?vue&type=script&lang=js&"
import style0 from "./td-tradeOpt.vue?vue&type=style&index=0&id=81b06f0e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports